import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

// Ответ от сервера уже озвучен axios-интерцептором (client.ts) — второй тост поверх
// него был бы дублем. Здесь остаются только случаи, когда ответа не было вовсе:
// обрыв сети, таймаут, CORS.
function hasServerResponse(error: unknown): boolean {
  return Boolean(
    error &&
    typeof error === 'object' &&
    'response' in error &&
    (error as { response?: unknown }).response,
  )
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (query.meta?.silent || hasServerResponse(error)) {
        return
      }
      toast.error('Не удалось загрузить данные')
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      if (mutation.meta?.silent || hasServerResponse(error)) {
        return
      }
      toast.error('Не удалось выполнить действие')
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
})
